import Tool from '../../common/tool';
// import { fetchKefuWxUrl } from '../../common/kefuQrcode'
function isMobileHomepage() {
    return !!document.querySelector('link[href*="mobile/homepage"]');
}
var HomePageMain = /** @class */ (function () {
    function HomePageMain() {
        this.homeBannerSwiper = null;
        this.programmeDom = document.getElementById('kingshiper-programme');
        this.bindDomainCards();
        this.bindConsultKefu();
        this.bindHomeBanner();
        if (this.programmeDom) {
            this.init();
        }
    }
    HomePageMain.prototype.bindHomeBanner = function () {
        var _this = this;
        var bannerEl = document.getElementById('daetool-home-banner');
        if (!bannerEl || typeof Swiper === 'undefined') {
            return;
        }
        var slides = bannerEl.querySelectorAll('.swiper-slide');
        if (slides.length === 0) {
            bannerEl.hidden = true;
            return;
        }
        var multiple = slides.length > 1;
        var paginationEl = bannerEl.querySelector('.swiper-pagination');
        var nextEl = bannerEl.querySelector('.swiper-button-next');
        var prevEl = bannerEl.querySelector('.swiper-button-prev');
        var navWrap = bannerEl.querySelector('.swiper-button-wrap');
        if (!multiple) {
            paginationEl === null || paginationEl === void 0 ? void 0 : paginationEl.setAttribute('hidden', '');
            navWrap === null || navWrap === void 0 ? void 0 : navWrap.setAttribute('hidden', '');
        }
        // Swiper 4：不要传 pagination/navigation/autoplay 为 undefined/false，否则会覆盖默认对象导致读 .el 报错
        var swiperOptions = {
            watchOverflow: true,
            observer: true,
            observeParents: true,
        };
        if (multiple) {
            swiperOptions.loop = slides.length >= 3;
            swiperOptions.autoplay = {
                delay: 3000,
                disableOnInteraction: false,
            };
            if (paginationEl) {
                swiperOptions.pagination = {
                    el: paginationEl,
                    clickable: true,
                };
            }
            if (nextEl && prevEl) {
                swiperOptions.navigation = {
                    nextEl: nextEl,
                    prevEl: prevEl,
                };
            }
        }
        try {
            this.homeBannerSwiper = new Swiper(bannerEl, swiperOptions);
        }
        catch (err) {
            console.error('[homepage] Swiper 初始化失败:', err);
            return;
        }
        if (!multiple) {
            return;
        }
        slides.forEach(function (slide) {
            slide.addEventListener('mouseenter', function () {
                var _a, _b, _c;
                (_c = (_b = (_a = _this.homeBannerSwiper) === null || _a === void 0 ? void 0 : _a.autoplay) === null || _b === void 0 ? void 0 : _b.stop) === null || _c === void 0 ? void 0 : _c.call(_b);
            });
            slide.addEventListener('mouseleave', function () {
                var _a, _b, _c;
                (_c = (_b = (_a = _this.homeBannerSwiper) === null || _a === void 0 ? void 0 : _a.autoplay) === null || _b === void 0 ? void 0 : _b.start) === null || _c === void 0 ? void 0 : _c.call(_b);
            });
        });
    };
    HomePageMain.prototype.init = function () {
        this.toggleTab();
    };
    HomePageMain.prototype.bindDomainCards = function () {
        var _this = this;
        var strengthBox = document.querySelector('.homepage-strength-box');
        if (!strengthBox) {
            return;
        }
        var container = strengthBox.querySelector('.homepage-strength-box__domain-cards');
        if (!container) {
            return;
        }
        var cards = Array.from(Tool.$_selectAll(container, '.domain-card'));
        if (isMobileHomepage()) {
            cards.forEach(function (card) {
                card.addEventListener('click', function (e) {
                    var target = e.target;
                    if (target.closest('.domain-card__consult-btn')) {
                        return;
                    }
                    var wasExpanded = card.classList.contains('is-expanded');
                    cards.forEach(function (item) { return item.classList.remove('is-expanded'); });
                    if (!wasExpanded) {
                        card.classList.add('is-expanded');
                    }
                });
            });
        }
        else {
            cards.forEach(function (card) {
                card.addEventListener('mouseenter', function () {
                    if (card.classList.contains('is-expanded')) {
                        return;
                    }
                    cards.forEach(function (item) { return item.classList.remove('is-expanded'); });
                    card.classList.add('is-expanded');
                    _this.replayDomainCardHoverAnimation(card);
                });
            });
        }
        this.initDomainCardsWow();
    };
    HomePageMain.prototype.initDomainCardsWow = function () {
        if (typeof WOW === 'undefined') {
            return;
        }
        new WOW({
            boxClass: 'wow',
            animateClass: 'animate__animated',
            offset: 80,
            mobile: true,
        }).init();
    };
    HomePageMain.prototype.replayDomainCardHoverAnimation = function (card) {
        card.querySelectorAll('.domain-card__title, .domain-card__list').forEach(function (el) {
            var node = el;
            node.style.animation = 'none';
            void node.offsetWidth;
            node.style.animation = '';
        });
    };
    HomePageMain.prototype.bindConsultKefu = function () {
        var consultBtns = document.querySelectorAll('.domain-card__consult-btn');
        consultBtns.forEach(function (btn) {
            btn.addEventListener('click', function (e) {
                if (isMobileHomepage()) {
                    e.preventDefault();
                    e.stopPropagation();
                    // fetchKefuWxUrl()
                    // 	.then((url) => {
                    // 		window.location.href = url;
                    // 	})
                    // 	.catch((err) => {
                    // 		console.error('获取企业微信客服链接失败:', err);
                    // 	});
                    window.open('https://work.weixin.qq.com/kfid/kfc4ed2005db8d41112', '_blank', 'noopener,noreferrer');
                }
            });
        });
    };
    HomePageMain.prototype.toggleTab = function () {
        if (!this.programmeDom) {
            return;
        }
        var that = this;
        var programmeHeadListLis = Tool.$_selectAll(this.programmeDom, 'ul.kingshiper-programme-headList li');
        programmeHeadListLis.forEach(function (item) {
            item.addEventListener('mouseenter', function () {
                programmeHeadListLis.forEach(function (pItem) { return pItem.classList.remove('active'); });
                item.classList.add('active');
                var className = item.getAttribute('data-type');
                var programmeContentListLi = Tool.$_select(that.programmeDom, "ul.kingshiper-programme-contentList li.".concat(className));
                var programmeContentListLis = Tool.$_selectAll(that.programmeDom, 'ul.kingshiper-programme-contentList li');
                programmeContentListLis.forEach(function (pItem) { return pItem.classList.remove('active'); });
                programmeContentListLi.classList.add('active');
                switch (className) {
                    case 'video':
                    case 'online':
                        that.programmeDom.classList.remove('blue-bg');
                        that.programmeDom.classList.remove('green-bg');
                        that.programmeDom.classList.add('purple-bg');
                        break;
                    case 'office':
                    case 'system':
                    case 'picture':
                        that.programmeDom.classList.remove('purple-bg');
                        that.programmeDom.classList.remove('green-bg');
                        that.programmeDom.classList.add('blue-bg');
                        break;
                    case 'audio':
                    case 'data':
                        that.programmeDom.classList.remove('purple-bg');
                        that.programmeDom.classList.remove('blue-bg');
                        that.programmeDom.classList.add('green-bg');
                        break;
                }
            });
        });
        var programmeHeadListFirstLi = Tool.$_select(this.programmeDom, 'ul.kingshiper-programme-headList li:first-child');
        programmeHeadListFirstLi.classList.add('active');
        var programmeContentListFirstLi = Tool.$_select(this.programmeDom, 'ul.kingshiper-programme-contentList li:first-child');
        programmeContentListFirstLi.classList.add('active');
        this.programmeDom.classList.add('purple-bg');
    };
    return HomePageMain;
}());
export default HomePageMain;
